export default { 

	"modules":[
	{
		"name" 				: "Dashboard",
		"module" 			: "dashboard",
		"modul" 			: "dashboard",
		"enable" 			: true,
		"isView"  			: true,
		"icon" 				: "mdi-view-dashboard",
		"type" 				: "url",
		"roles" 			: [1,  2, 3],
		"type_component" 	: "module"
	},
	{
		"name": "Add Device",
		"module": "device",
		"modul" 			: "device",
		"enable": true,
		"isView"  : true,
		"icon": "mdi-devices",
		"type": "url",
		"roles": [1,  2, 3],
		"type_component" : "module",		
		"assosiated_routes" : [ "device", "new_device", "new_peripheral", "setting_device", "playback", "setting_analytic" ],
		"assosiateds" 		: [
			{
				"sub_module" 		: "new_device",
				"module" 	 		: "device",
				"enable" 	 		: true,
				"type_component" 	: "route",
				"modul" 			: "device",
				"roles" 	 		: [1, 2]
			},
			{
				"sub_module" : "new_peripheral",
				"module" 	 : "new_peripheral",
				"modul" 	 		: "device",
				"enable" 	 : true,
				"type_component" : "route",
				"roles" 	 : [1, 2]
			},
			{
				"sub_module" : "setting_device",
				"module" 	 : "setting_device",
				"modul" 	 		: "device",
				"enable" 	 : true,
				"type_component" : "route",
				"roles" 	 : [1, 2]
			},
			{
				"sub_module" : "setting_analytic",
				"module" 	 : "setting_analytic",
				"modul" 	 		: "device",
				"enable" 	 : true,
				"type_component" : "route",
				"roles" 	 : [1, 2]
			}
		]
	},
	
	{ 
		"name": "NVR",		
		"module": "nvr",		
		"modul": "nvr",		

		"enable": true,
		"isView"  : true,
		"icon": "mdi-animation-play-outline",
		"roles": [1,  2, 3],
	    "type_component" : "module",
		
		"sub_modules" :[			
			{
				"name": "Playback",
				"sub_module": "playback",
				"module" 		: "playback",
				"modul": "nvr",		
				"title" : "playback",
				"enable": true,
				"isView"  : true,
				"type": "url",
				"icon": "mdi-play-box-multiple",
				"type_component" : "route",
				"roles": [1, 2, 3]
			},
			/*{
              	"name": "Reports",
              	"sub_module": "reports", 
				"module" 		: "reports",
				"modul": "nvr",		
				"type_component" : "route",
              	"enable" : false,
				"isView"  : false,
				"type": "url",				
              	"title": "reports",
              	"icon": "mdi-file-chart",
              	"roles": [1, 2, 3]
	        },
			{
				"name": "Streaming",
				"sub_module": "streaming",
				"module" 		: "Streaming",
				"modul": "nvr",		
				"type_component" : "route",
				"title" : "streaming",
				"enable": false,
				"isView"  : true,
				"type": "url_",
				"icon": "mdi-cctv",
				"roles": [1,  2]
			}*/
		]
	},
	/*{
		"name": "Reports",
		"module": "reports",
		"modul" : "reports",
		"enable": false,
		"isView"  : false,
		"type": "url",
		"icon": "mdi-file-chart",
		"roles": [1,  2, 3],
		"type_component" : "module",
		"assosiated_routes" : [ ]
	},	*/
	{
		"name": "Zones",
		"module": "zones",
		"enable": true,
		"modul" : "zones",
		"isView"  : true,
		"type": "url",
		"icon": "mdi-map-marker-star",
		"roles": [1,  2],
		"type_component" 	: "module",
		"assosiated_routes" : [ "settings_zones" ],
		"assosiateds" 		: [
			{
				"sub_module" 	: "settings_zones",
				"module" 		: "settings_zones",
				"modul" 		: "zones",
				"enable" 	 	: true,	            
				"type_component" : "route",
				"roles" 	 	: [1, 2]
			}
		]
	},	
	{
		"name": "list",
		"module": "lists",
		"modul" : "lists",
		"enable": true,
		"isView"  : true,
		"icon": "mdi-file",
		"type": "url",
		"roles": [1,  2],
		"type_component" 	: "module",
		"assosiated_routes" : [  ],		
		"assosiateds" 		: [
			{
				"sub_module" 		: "listing_setting",
				"module" 			: "listing_setting",
				"modul" 			: "lists",
				"enable" 	 		: true,	            
				"type_component" 	: "route",
				"roles" 	 		: [1, 2]
			},
			{
				"sub_module" 		: "new_list",
				"module" 			: "new_list",
				"modul" 			: "lists",
				"enable" 	 		: true,	            
				"type_component" 	: "route",
				"roles" 	 		: [1, 2]
			}
		]
	},
	{
		"name": "profiles",
		"module": "profiles",
		"modul" : "profiles",
		"enable": true,
		"isView"  : true,
		"icon": "mdi-face-man-profile",
		"type": "url",
		"roles": [1,  2],
		"type_component" 	: "module",
		"assosiated_routes" : [  ],
		"assosiateds" 		: [
			{
				"sub_module" 		: "profile_settings",
				"module" 			: "profile_settings",
				"modul" 			: "profiles",
				"enable" 	 		: true,	            
				"type_component" 	: "route",
				"roles" 	 		: [1, 2]
			}
		]
	},
	{ 	
		"name": "LPR",				
		"module": "lpr",
		"modul" : "lpr",
		"enable": true,
		"isView"  : true,
		"type": "btn",
	    "icon": "mdi-card-text",		        
	    "type_component" : "module",
	    "roles": [1,  2, 3], 	    
	    "sub_modules": 
          	[                		
	            {
	              	"name": "Reports_lpr",
	              	"sub_module": "reports_lpr", 
	              	"module" 		: "reports_lpr", 
					"modul" : "lpr",
	              	"title": "reports",
	              	"enable" : true,
	              	"icon": "mdi-file-chart",
	              	"roles": [1, 2, 3],
					"type_component" 	: "route",
					"type" 			: "url"

	            },
	            {
	              	"name": "List",
	              	"sub_module" 	: "list_lpr", 
	              	"module" 		: "list_lpr", 
					"modul" : "lpr",
	              	"title": "list",
	              	"enable" : true,
	              	"icon": "mdi-format-list-bulleted-square",
	              	"roles": [1,  2],
					"type_component" 	: "route",
					"type" 			: "url"

	            }
	        ],
	    "components":
			[
				"events", "alerts"
			]
	},
	{ 	
		"name": "Parking",				
		"module": "parking",
		"modul" : "parking",
		"enable": true,
		"isView"  : true,
		"type": "btn",
	    "icon": "mdi-parking",		        
	    "roles": [1,  2, 3], 	    
	    "type_component" : "module",
	    "sub_modules": 
          	[                		
	            {
	              	"name": "Managers",
	              	"sub_module": "managers_parking",
	              	"module" 			: "managers_parking", 
					"modul" : "parking",
	              	"title": "managers",
					"enable" : false,
	              	"icon": "mdi-format-list-bulleted-square",
	              	"roles": [1,  2],
					"type_component" 	: "route",
					"type" 			: "url"

	            },
	            {
					"name": "Reports_parking",
					"sub_module": "reports_parking",
					"module": "reports_parking",
					"modul": "parking",
					"title": "reports",
					"enable": false,
					"icon": "mdi-file-chart",
					"roles": [1, 2, 3],
					"type_component": "route",
					"type": "url"

	            },
	            {
	              	"name": "List",
	              	"sub_module": "list_parking", 
	              	"module" 			: "list_parking", 
					"modul" : "parking",
	              	"title": "list",
	              	"enable" : true,
	              	"icon": "mdi-format-list-bulleted-square",
	              	"roles": [1,  2],
					"type_component" 	: "route",
					"type" 			: "url"

	            }
	        ]
	
	},
	{ 	
		"name" 				: "AVC",				
		"module" 			: "avc",
		"modul" 			: "avc",
		"enable" 			: true,
		"isView"  			: true,
		"type" 				: "btn",
	    "icon" 				: "mdi-axis",		        
	    "type_component" 	: "module",
	    "roles" 			: [1,  2, 3], 	    
	    "sub_modules"		: [                		
            {
              	"name" 				: "Reports_avc",
              	"sub_module" 		: "reports_avc", 
              	"module" 			: "reports_avc", 
				"modul" 			: "avc",
              	"title" 			: "reports",
              	"enable" 			: true,
              	"icon" 				: "mdi-file-chart",
              	"roles" 			: [1, 2, 3],
				"type_component" 	: "route",
				"type" 				: "url"

            }
	    ]	    
	},
	/*{ 	
		"name": "Anomalies",				
		"module": "anomalies",
		"modul" : "anomalies",
		"enable": false,
		"type": false,
	    "icon": "mdi-card-text",		        
	    "roles": [1,  2, 3], 
	    "sub_modules": 
          	[],
	    "components":
			[]
	},
	{ 	
		"name": "Human actions",				
		"module": "human_actions",
		"modul" : "human_actions",
		"enable": false,
		"type": false,
	    "icon": "mdi-card-text",		        
	    "roles": [1,  2, 3], 
	    "sub_modules": 
          	[],
	    "components":
			[]
	},
	{ 	
		"name": "Persons",				
		"module": "person",
		"modul": "person",
		"enable": false,
		"type": false,
	    "icon": "mdi-card-text",		        
	    "roles": [1,  2, 3], 
	    "sub_modules": 
          	[],
	    "components":
			[]
	},
	{ 
		"name": "Blacklist",		
		"module": "blacklist",				
		"modul" : "blacklist",				
		"enable": false,
		"icon": "mdi-file-alert",
		"roles": [1,  2]
	},
	{ 
		"name": "RFID",		
		"module": "rfid",
		"modul" : "rfid",
		"enable": false,
		"icon": "",
		"roles": [1,  2]
	},*/
	{ 	
		"name": "FACE",		
		"module": "face",
		"modul" : "face",
		"type": "url",
		"isView"  : true,
		"enable": true,
		"icon": "mdi-face-recognition",
		"type_component" 	: "module",
		"roles": [1,  2, 3],
		"components":
	   		[
	   			"recognized", "detected_faces"
	  		],
	  	"sub_modules": 
          	[                		
	            {
	              	"name" 				: "Managers",
	              	"sub_module"		: "trained",
	              	"module" 			: "trained", 
					"modul" 			: "face",
	              	"title" 			: "trained",
	              	"enable" 			: true,
	              	"icon" 				: "mdi-format-list-bulleted-square",
	              	"roles" 			: [1,  2],
					"type_component" 	: "route",
					"type" 				: "url"

	            },
	              {
	              	"name": "List",
	              	"sub_module" 	: "list_face", 
	              	"module" 		: "list_face", 
					"modul" 		: "face",
	              	"title" 		: "list",
	              	"enable" 		: true,
	              	"icon" 			: "mdi-format-list-bulleted-square",
	              	"roles" 		: [1,  2],
					"type_component" 	: "route",
					"type" 			: "url"

	            },
	            {
	              	"name": "List",
	              	"sub_module" 	: "reports_face", 
	              	"module" 		: "reports_face", 
					"modul" 		: "face",
	              	"title" 		: "reports",
	              	"enable" 		: true,
	              	"icon" 			: "mdi-file-chart",
	              	"roles" 		: [1,  2, 3],
					"type_component" 	: "route",
					"type" 			: "url"
	            },
	            {
	              	"name": "List",
	              	"sub_module" 	: "search_by_video_face", 
	              	"module" 		: "search_by_video_face", 
					"modul" 		: "face",
	              	"title" 		: "search_by_video_face",
	              	"enable" 		: true,
	              	"icon" 			: "mdi-video-account",
	              	"roles" 		: [1,  2, 3],
					"type_component" 	: "route",
					"type" 			: "url"
	            },
	    	]
	},
	/*{ 	
		"name": "Guns",				
		"module": "gun",
		"modul" : "gun",
		"enable": false,
		"type": false,
	    "icon": "mdi-card-text",		        
	    "roles": [1,  2, 3], 
	    "sub_modules1": 
          	[ "weapon_detector" ], 
	    "components":
			[ "events" ]
	},
	{ 	
		"name": "Weapon detector",		
		"module": "weapon_detector",
		"modul" : "weapon_detector",
		"enable": false,	
		"isView"  : true,
		"required" : "gun",
		"type": "url",
		"icon": "mdi-vector-square",
		"roles": [1,  2, 3],
		"sub_modules": [				
				{
					"name" : "sz_contacts",
					"sub_module": "sz_contacts",								
					"modul" : "weapon_detector",
					"title": "contact_list",
					"icon": "mdi-format-list-bulleted-square",
					"type" 			: ""
				}
			]
	},
	{ 					
		"name": "TRAFFIC",
		"module": "traffic",
		"modul" : "traffic",
		"enable": false,
		"icon": "",
		"roles": [1,  2]
	},
	{ 					
		"name": "OBJECTS",
		"module": "objects",
		"modul" : "objects",
		"enable": true,
		"type" : false,
		"icon": "",
		"roles": [1,  2],
		"sub_modules": 
          	[         
            	"zones", "alarms", "streaming"
	        ],
	   	"components":
	   		[
	   			"zone", "event", "timeline"
	  		]
	},
	{ 					
		"name": "MOTION",
		"module": "motion",
		"modul" : "motion",
		"enable": true,
		"type" : false,
		"icon": "",
		"roles": [1,  2],
		"sub_modules": 
          	[         
            	"zones", "alarms", "streaming"
	        ],
	    "components":
	   		[
	   			"zone", "event", "timeline"
	  		]

	},*/
	{
		"name": "workspaces",
		"module": "workspaces",
		"modul" : "workspaces",
		"enable": true,
		"isView"  : true,
		"type": "url",
		"icon": "mdi-monitor-multiple",
		"type_component" 	: "module",
		"roles": [1,  2],
		"assosiated_routes" : [  ]
	},
	{
		"name": "contacts",
		"module": "contacts",
		"modul" : "contacts",
		"enable": true,
		"isView"  : true,
		"type": "url",
		"icon": "mdi-contacts",
		"roles": [1,  2],
		"type_component" 	: "module",
		"assosiated_routes" : [  ],
		"assosiateds" 		: [
			{
				"sub_module" : "new_contact",
				"modul" 	 : "contacts",
				"module" 	 : "new_contact",
				"type_component" 	: "route",
				"enable" 	 : true,
				"roles" 	 : [1, 2]
			},
			{
				"sub_module" : "settings_contact",
				"modul" 	 : "contacts",
				"module" 	 : "settings_contact",
				"type_component" 	: "route",
				"enable" 	 : true,
				"roles" 	 : [1, 2]
			}
			
		]
	},
	 
	{
		"name": "Smart event",
		"module": "smart_event",
		"modul" : "smart_event",
		"enable": true,
		"isView"  : true,
		"type": "url",
		"icon": "mdi-gesture-tap-button",
	    "type_component" : "module",
		"roles": [1,  2, 3],
		"assosiated_routes" : [ "alarms", "settings_alarm" ],
		"sub_modules" :[
			{
              	"name": "smart_event",
              	"sub_module": "smart_event", 
              	"module" 			: "smart_event", 
				"modul" : "smart_event",
              	"title": "manage",
              	"icon": "mdi-cellphone-cog",
              	"enable" : true,
              	"roles": [1,  2],
				"type_component" 	: "route",
				"type" 			: "url"

	        },	       
			{
              	"name" 				: "List",
              	"sub_module" 		: "reports_alarms",
              	"module" 	 		: "reports_alarms",               	 
				"modul" 			: "smart_event",
              	"title"				: "reports",
              	"icon" 				: "mdi-file-chart",
              	"enable" 			: true,
              	"roles" 			: [1,  2, 3],
				"type_component" 	: "route",
				"type" 				: "url"


	        }
	    ],
	    "assosiateds" 		: [
			{
				"sub_module" : "settings_alarm",
				"modul" 	 : "smart_event",
				"type_component" 	: "route",
				"module" 	 : "settings_alarm",
				"enable" 	 : true,
				"roles" 	 : [1, 2]
			}
		]
	},
	{
      	"name" 		 : "User", 
      	"module"  	 : "user", 
      	"modul"  	 : "user", 
      	"title" 	 : "user", 
      	"icon" 		 : "mdi-account",
      	"enable" 	 : true,	
		"isView"     : true,
		"type"  	 : "url",
		"type_component" 	: "module",
		"roles" 	 : [1,  2]
	},
	{
		"name": "Settings",
		"module" : "settings",
		"modul"  : "settings",
		"type": "url",
		"enable": true,
		"isView": true,
		"icon": "mdi-cog",
		"type_component" 	: "module",
		"roles": [1,  2],		
		"assosiateds" 		: [
			{
				"sub_module" 		: "not_access_view",
				"module" 	 		: "not_access_view",
				"modul"  			: "settings",
				"type_component" 	: "module",
				"enable" 	 		: true,
				"roles" 	 		: [1, 2, 3]
			},
			{
				"sub_module" 		: "*",
				"module" 			: "*",
				"modul"  			: "settings",
				"type_component" 	: "module",
				"enable" 	 		: true,
				"roles" 	 		: [1, 2, 3]
			},
			{
				"sub_module" 		: "login",
				"module" 			: "login",
				"modul"  			: "login",
				"type_component" 	: "module",
				"enable" 	 		: true,
				"roles" 	 		: [1, 2, 3]
			},
			{
				"sub_module" 		: "profile",
				"modul"  			: "user",
				"module" 			: "profile",
				"type_component" 	: "module",
				"enable" 	 		: true,
				"roles" 	 		: [1, 2, 3]
			}

		]
	}
	

	]
}
